import { useQueryData } from "hooks";
import { GET_CONNECTIONS } from "graphql/queries";

/**
 * useConnections
 *
 * @param {Object} filters
 */
export default function useConnections({ filters }) {
  const {
    loading,
    data: response,
    error,
  } = useQueryData({
    queryName: GET_CONNECTIONS,
    keyName: "connections",
    variables: { filters },
  });

  return {
    loading,
    connections: response?.connections?.nodes,
    error,
  };
}
